import { Navigate, createBrowserRouter, type RouteObject } from 'react-router';

import { ApplyIndexPage, ApplyStepPage } from '@/features/application/pages/apply-page';
import { NoRecentApplicationPage } from '@/features/application/pages/no-recent-application-page';
import { WaitingRoomPage } from '@/features/application/pages/waiting-room-page';
import { FinishAccountPage } from '@/features/auth/pages/finish-account-page';
import { NewPasswordPage } from '@/features/auth/pages/new-password-page';
import { SignInPage } from '@/features/auth/pages/sign-in-page';
import { StartPage } from '@/features/auth/pages/start-page';
import { RequireAuth } from '@/features/auth/require-auth';

import { ErrorPage } from './error-page';
import { NotFoundPage } from './not-found-page';
import { RedirectKeepingQuery } from './redirect-keeping-query';

export const routes: RouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      { path: '/', element: <RedirectKeepingQuery to="/welcome" /> },
      { path: '/welcome', element: <StartPage /> },
      { path: '/welcome/finish', element: <FinishAccountPage /> },
      { path: '/sign-in', element: <SignInPage /> },
      { path: '/sign-in/forgot', element: <SignInPage /> },
      // The service's reset e-mail links here; the path is part of its contract.
      { path: '/newPassword/:key', element: <NewPasswordPage /> },
      {
        element: <RequireAuth />,
        children: [
          { path: '/apply', element: <ApplyIndexPage /> },
          { path: '/apply/:step', element: <ApplyStepPage /> },
          // camelCase on purpose: the Google Ads conversion in the shared GTM container
          // fires on a history change to a path containing `/waitingRoom`.
          { path: '/waitingRoom', element: <WaitingRoomPage /> },
          { path: '/no-recent-application', element: <NoRecentApplicationPage /> },
        ],
      },
      // Old hub bookmarks and job-board links. The job board's Apply button links to
      // `/welcome/signUp?jobId=…`, so these keep the query string.
      //
      // `/confirmation/:id` is not a bookmark: candidate-portal-service mails that
      // link on sign-up (notification/send_confirmation_email.go) and those e-mails
      // outlive the hub. candidate-service dropped e-mail confirmation, so there is
      // nothing left to confirm - but the account exists, so send them to sign-in
      // rather than the 404 page they would otherwise hit via `*`.
      { path: '/confirmation/:id', element: <Navigate to="/sign-in" replace /> },
      { path: '/welcome/signUp', element: <RedirectKeepingQuery to="/welcome" /> },
      { path: '/welcome/sign-up', element: <RedirectKeepingQuery to="/welcome" /> },
      { path: '/welcome/forgot', element: <RedirectKeepingQuery to="/sign-in/forgot" /> },
      { path: '/onboarding', element: <Navigate to="/apply" replace /> },
      { path: '/recentapplication', element: <Navigate to="/no-recent-application" replace /> },
      { path: '/404', element: <NotFoundPage /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
